export default "images/实时路线导航+前车风险提示.png";